import { userLeavesDataExchangePage } from "./../../store/data-exchange.actions";
import { Store } from "@ngrx/store";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { DestroyableDirective } from "@app/abstract/destroyable";
import { takeUntil } from "rxjs/operators";
import * as AuthenticationSelectors from "@app/shared/state/authentication/authentication.selectors";

@Component({
    selector: "app-data-exchange-page",
    templateUrl: "./data-exchange-page.component.html",
    standalone: false
})
export class DataExchangePageComponent
  extends DestroyableDirective
  implements OnInit, OnDestroy
{
  constructor(private _store: Store) {
    super();
  }

  userType: string;

  ngOnDestroy(): void {
    this._store.dispatch(userLeavesDataExchangePage());
  }

  ngOnInit() {
    this._store
      .select(AuthenticationSelectors.selectUserType)
      .pipe(takeUntil(this.destroy$))
      .subscribe((userType) => {
        this.userType = userType;
      });
  }
}
